import {
    HTTP
} from '@/utilities/http-common';

export default {
    namespaced: true,
    state: {
        count: 0
    },
    getters: {},
    mutations: {
        setCount(state, count) {
            state.count = count;
        },
        getCount(state) {
            return state.count;
        }
    },
    actions: {
        setStructureFinalCompletedCount({
            commit
        }, count) {
            commit('setCount', count);
        },
        getStructureFinalCompletedCount() {
            return HTTP.get('/kenya/structures/get_completed_count');
        }
    },
}